import { render, staticRenderFns } from "./Log.vue?vue&type=template&id=bad4dd3a&scoped=true&"
import script from "./Log.vue?vue&type=script&lang=js&"
export * from "./Log.vue?vue&type=script&lang=js&"
import style0 from "./Log.vue?vue&type=style&index=0&id=bad4dd3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4dd3a",
  null
  
)

export default component.exports